import React from 'react';
interface HeroProps {
  onOpenModal: () => void;
}
export function Hero({
  onOpenModal
}: HeroProps) {
  return <section className="relative min-h-screen flex items-center justify-center bg-black text-white overflow-hidden" data-id="element-71">
      {/* Decorative geometric patterns */}
      <div className="absolute inset-0 opacity-10" data-id="element-72">
        <div className="absolute top-20 left-20 w-64 h-64 border-2 border-yellow-600 rotate-45" data-id="element-73"></div>
        <div className="absolute bottom-20 right-20 w-64 h-64 border-2 border-yellow-600 rotate-45" data-id="element-74"></div>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-6 py-20 text-center" data-id="element-75">
        {/* Logo */}
        <div className="mb-12 flex justify-center" data-id="element-76">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ti4jjWAMuSQQwcf4QUqPyN/logo_sambocard.png" alt="SamboCard Logo" className="w-64 h-64 object-contain" data-id="element-77" />
        </div>

        {/* Headline */}
        <h1 className="text-5xl md:text-7xl font-bold mb-6 bg-gradient-to-r from-yellow-400 via-yellow-200 to-yellow-400 bg-clip-text text-transparent" data-id="element-78">
          Tu Tarjeta de Beneficios
        </h1>

        <p className="text-xl md:text-2xl text-gray-300 mb-4 max-w-3xl mx-auto" data-id="element-79">
          Descuentos exclusivos en cientos de comercios
        </p>

        <p className="text-lg md:text-xl text-yellow-400 font-semibold mb-12" data-id="element-80">
          100% Gratuita para siempre
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col items-center gap-6" data-id="element-81">
          <button onClick={onOpenModal} className="px-8 py-4 bg-gradient-to-r from-yellow-600 to-yellow-500 text-black font-bold text-lg rounded-lg hover:from-yellow-500 hover:to-yellow-400 transition-all transform hover:scale-105 shadow-lg shadow-yellow-600/50" data-id="element-82">
            Obtener Mi Tarjeta
          </button>

          {/* App Store Badges */}
          <div className="flex flex-col sm:flex-row gap-4 items-center" data-id="element-83">
            <a href="https://apps.apple.com/cl/app/sambocard/id6755863755" target="_blank" rel="noopener noreferrer" className="transition-transform hover:scale-105" data-id="element-84">
              <img src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" alt="Descargar en App Store" className="h-14 w-auto" data-id="element-85" />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.ipse.cedes.sambocard" target="_blank" rel="noopener noreferrer" className="transition-transform hover:scale-105" data-id="element-86">
              <img src="https://play.google.com/intl/en_us/badges/static/images/badges/es_badge_web_generic.png" alt="Disponible en Google Play" className="h-14 w-auto" data-id="element-87" />
            </a>
          </div>
        </div>

        {/* Features badges */}
        <div className="mt-16 flex flex-wrap justify-center gap-8 text-sm" data-id="element-88">
          <div className="flex items-center gap-2" data-id="element-89">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hEpkLUT3iQDUBGhstXjfYR/iconos_gratuita.gif" alt="Gratuita" className="w-5 h-5" data-id="element-90" />
            <span className="text-gray-300" data-id="element-91">Gratuita</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-92">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qhWkgiHHKyQgkFDqY1sPLe/iconos_activacion.gif" alt="Activación inmediata" className="w-5 h-5" data-id="element-93" />
            <span className="text-gray-300" data-id="element-94">Activación inmediata</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-95">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mVhUz28Cf8FtcqpBN1ewxt/iconos_descuento.gif" alt="Descuentos ilimitados" className="w-5 h-5" data-id="element-96" />
            <span className="text-gray-300" data-id="element-97">Descuentos ilimitados</span>
          </div>
        </div>
      </div>
    </section>;
}